import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'formly-multi-social-input',
    template: `
    <div class="mb-2">
      <label *ngIf="getControls().length != 0 && props.label" class="form-label">{{ props.label }}</label>
      
      <div *ngFor="let group of getControls(); let i = index" [formGroup]="group" class="d-flex align-items-center gap-2">
 
        <input type="text" formControlName="label" placeholder="{{'Social' | translate}}" class="form-control flex-grow-1" (input)="emitChanges()" />
        <input type="text" formControlName="socialUrl" placeholder="URL" class="form-control flex-grow-1" (input)="emitChanges()" />
 
        <button type="button" mat-icon-button (click)="removeField(i)">
          <span class="material-symbols-rounded icon d-flex align-items-center">{{'close' | translate}}</span>
        </button>
      </div>
  
      <div class="d-flex justify-content-start mt-1">
        <button style="height:32px !important;" type="button" class="btn btn-link d-flex justify-content-start text-primary p-0" (click)="addField()">
        <span style="font-weight: 400;">   {{getButtonText() }}</span>
        </button>
      </div>
    </div>
  `,
    styles: [
        `
      .icon {
        font-size: 24px;
      }
    `,
    ],
    standalone: false
})
export class MultiSocialInputComponent extends FieldType implements OnInit {

    constructor(private translateService: TranslateService) {
        super();
    }

    ngOnInit() {
        if (!(this.formControl instanceof FormArray)) {
            (this.field as any).formControl = new FormArray([]);
        }
        this.initializeFields();
    }

    get formArray(): FormArray {
        return this.formControl as FormArray;
    }

    getControls(): FormGroup[] {
        return this.formArray.controls as FormGroup[];
    }

    private initializeFields() {
        const fields = this.props?.['defaultValue'] || this.props?.['fields'] || [];

        if (fields.length === 0) {
            this.formArray.push(this.createContactSocialGroup());
        } else {
            this.formArray.clear();
            fields.forEach((field: any) => {
                this.formArray.push(this.createContactSocialGroup(field));
            });
        }

        this.emitChanges();
    }

    private createContactSocialGroup(data: Partial<any> = {}): FormGroup {
        return new FormGroup({
            id: new FormControl(data['id'] || undefined),
            socialUrl: new FormControl(data['socialUrl'] || ''),
            label: new FormControl(data['label'] || ''),
        });
    }

    addField() {
        this.formArray.push(this.createContactSocialGroup());
        this.emitChanges();
    }

    removeField(index: number) {
        this.formArray.removeAt(index);
        this.emitChanges();
    }

    getButtonText() {
        return this.translateService.instant('Add Socials') + ` (${this.formArray.length})`;
    }

    emitChanges() {
        const values = this.formArray.value;
        this.props['onValuesChange']?.(values);
    }
}
